'use strict';

function LoanApplicationConnectBank() {
  var _this = this;

  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._classes = {
    moreInfo: '.js--moreinfo_anchor',
    moreInfoDialog: '.js--loan-connect-bank-dialog__more_info',
    emailUsDocuments: '.js--email-us-documents',
    connectBtn: '.js--connect',
    prevBtn: '.js--previous'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();

    this._$node = $(this.node);

    // Elements
    this._$moreInfoDialogUrl = this._$node.find(this._classes.moreInfo);
    this._$moreInfoDialog = $(this._classes.moreInfoDialog);
    this._$prevBtn = this._$node.find(this._classes.prevBtn);
    this._$connectBtn = this._$node.find(this._classes.connectBtn);
    this._$emailUsDocuments = this._$node.find(this._classes.emailUsDocuments);

    this._setupEventHandlers();
  };

  this.initPage = function () {
    this.analytics.forcePushEvent('virtual-page-view');
    this.analytics.forcePushEvent('mogo-money-status', null, this);

    // Remove Page Progress loader
    this._removeProgressLoader();
  };

  this.destroy = function () {
    if (this._$moreInfoDialog.length) this._$moreInfoDialog.mogo().destroy();

    this._super();
  };

  this._setupEventHandlers = function () {
    // Dialog Event
    _this._$moreInfoDialogUrl.on('click', function (e) {
      e.preventDefault();
      _this._$moreInfoDialog.mogo().show();
    });

    _this._$prevBtn.on('click', function (e) {
      _this._history.goToUrl(_this.paths.loans.application_flow_bank);
    });

    _this._$emailUsDocuments.on('click', function (e) {
      _this._history.goToUrl(_this.paths.loans.application_flow_email_bank);
    });

    _this._$connectBtn.on('click', function (e) {
      _this._history.goToUrl(_this.paths.loans.application_flow_connect_to_bank_service);
    });
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };
}